import React from 'react';

type LoadingProps = {
  message?: string;
};

const Loading: React.FC<LoadingProps> = ({ message = 'Loading, please wait...' }) => {
  return (
    <div className='flex flex-col w-screen h-screen items-center justify-center space-y-2'>
      <div className='custom-spinner' />
      <p className='text-vulcan-950'>{message}</p>
    </div>
  );
};

export default Loading;
